import { Toast } from '..';
import { CloseToastContext, ShowToastContext } from './context';
import { useToastHandler } from './hooks';
import styles from './styles.module.scss';

type Props = {
  children: React.ReactNode;
};

export const ToastProvider: React.FC<Props> = props => {
  const { toasts, showToast, closeToast } = useToastHandler();

  return (
    <ShowToastContext.Provider value={{ showToast }}>
      <CloseToastContext.Provider value={{ closeToast }}>
        <div className={styles.wrapper}>
          {toasts.map(toast => (
            <Toast key={toast.toastId} {...toast} />
          ))}
        </div>
      </CloseToastContext.Provider>
      {props.children}
    </ShowToastContext.Provider>
  );
};
